type GlowPosition = 'top' | 'bottom' | 'center' | 'right' | 'top-left' | 'bottom-right';

const POSITIONS: Record<GlowPosition, string> = {
  top: '50% 18%',
  bottom: '50% 92%',
  center: '50% 60%',
  right: '80% 60%',
  'top-left': '20% 18%',
  'bottom-right': '80% 88%',
};

interface SectionGlowProps {
  position?: GlowPosition;
}

/**
 * Marketing radial glow. Gold at 28% opacity fading to transparent at 70%,
 * sized ~60% x 45% of the parent section. Parent must be `relative`.
 */
export function SectionGlow({ position = 'center' }: SectionGlowProps) {
  const pos = POSITIONS[position];
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
    >
      <div
        className="absolute inset-0"
        style={{
          background: `radial-gradient(ellipse 60% 45% at ${pos}, hsl(var(--gold) / 0.28) 0%, hsl(var(--gold) / 0.12) 35%, transparent 70%)`,
        }}
      />
    </div>
  );
}
